import { useEffect } from 'react';

/**
 * Batch 7 item 2: opt a screen out of the global print block.
 *
 * By default every signed-in screen has a global `@media print` rule
 * that hides the body and prints only one line:
 *   "Printing is not available. Axiom material is protected by copyright."
 *
 * Screens that must still print — reports, certificates, hand-off
 * artefacts (QR, shopping list), admin exports and the user's own writing
 * (journal, Relapse Prevention Plan, Self-Work answers) — call this hook
 * to tag the body with `arp-allow-print`, which disables the block for
 * the lifetime of that screen.
 */
export default function useAllowPrint() {
  useEffect(() => {
    document.body.classList.add('arp-allow-print');
    return () => {
      document.body.classList.remove('arp-allow-print');
    };
  }, []);
}
